import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import { authenticateUser } from '../services/authenticationServices';
import { Button, FormField, TextInput, Pane, Heading, Alert, majorScale } from 'evergreen-ui';
import { KeyIcon, PersonIcon, LogInIcon } from 'evergreen-ui';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth < 768 : true));
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      const result = await authenticateUser(email, password);

      if (result) {
        const role = result.session.role;
        const id = result.session.user_id;
        login(email, role, id);
        navigate(role === 'operatore' ? '/areaOperatori' : role === 'educatore' ? '/areaEducatori' : '/areaDirettore');
      } else {
        setErrorMessage('Credenziali non valide. Riprova.');
      }
    } catch (error) {
      console.error('Errore durante il login:', error);
      setErrorMessage('Errore di rete. Controlla la connessione e riprova.');
    }
  };

  return (
    <Pane
      className="login-container"
      display="flex"
      alignItems="center"
      justifyContent="center"
      background="tint1"
      style={{ minHeight: isMobile ? '100vh' : '60vh', padding: majorScale(3), width: '100%' }}
    >
      <Pane
        elevation={3}
        background="white"
        borderRadius={8}
        padding={isMobile ? majorScale(3) : majorScale(2)}
        style={{ width: '100%', maxWidth: isMobile ? 420 : 640, boxSizing: 'border-box', borderTop: '6px solid #d4dfc9' }}
      >
        <Heading size={700} marginBottom={24} textAlign="center" color="muted">
          Area Riservata
        </Heading>
        <form onSubmit={handleLogin}>
          <FormField 
            label={<><PersonIcon marginRight={8} />Email</>} 
            labelFor="email" 
            marginBottom={16} 
            labelProps={{ fontSize: 18, fontWeight: 500 }} 
          >
            <TextInput
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Inserisci la tua email..."
              required
              width="100%"
            />
          </FormField>
          <FormField 
            label={<><KeyIcon marginRight={8} />Password</>} 
            labelFor="password" 
            marginBottom={16} 
            labelProps={{ fontSize: 18, fontWeight: 500 }}
          >
            <TextInput
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la tua password..."
              required
              width="100%"
            />
          </FormField>
          {errorMessage && (
            <Alert intent="danger" title={errorMessage} marginBottom={16} />
          )}
          <Button
            appearance="primary"
            intent="success"
            type="submit"
            width="100%"
            height={48}
            fontSize={16}
            marginTop={16}
          >
            <LogInIcon marginRight={8} />Accedi
          </Button>
        </form>
      </Pane>
    </Pane>
  );
};

export default LoginPage;